"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSUPPORTED_STATES = void 0;
exports.UNSUPPORTED_STATES = ["AL", "NC", "VA", "MD"];